import { EventEmitter } from '@angular/core';
import { AddInfluencerGroup } from '../../../../models/influencer';
import { GroupService } from '../../../services/group-details/group.service';
import { InfluencerSuggestion, InfluencerSuggestionState } from '../../../../models/influencer-suggestion';
import { InfluencerGroup } from '../../../../models/influencer-group';
import { UserService } from '../../../services/user.service';
import { ModalService } from '../../../services/modal/modal.service';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { listOrderedPlatforms } from '../../../app.constants';
import { AutoSuggestionInfluencerComponent } from '../auto-suggestion-influencer/auto-suggestion-influencer.component';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { SendToReviewComponent } from '../../bottombar-influencer-fragement/send-to-review/send-to-review.component';
import { ActionSource, EventTrackerService, Page, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
var AddInfluencerGroupComponent = /** @class */ (function () {
    function AddInfluencerGroupComponent(groupService, userService, translate, influencerService, eventTracker, modalService) {
        this.groupService = groupService;
        this.userService = userService;
        this.translate = translate;
        this.influencerService = influencerService;
        this.eventTracker = eventTracker;
        this.modalService = modalService;
        this.influencerGroup = new InfluencerGroup();
        this.closeFragmentEvent = new EventEmitter();
        this.addInfluencerToGroupEvent = new EventEmitter();
        this.addNewInfluencerManuallyEvent = new EventEmitter();
        this.selectedInfluencers = [];
        this.platformList = [];
        this.listInfluencerBelongToCurrentGroup = [];
        this.reviewerList = [];
        this.platformList = listOrderedPlatforms;
    }
    AddInfluencerGroupComponent.prototype.ngOnInit = function () {
        // don't call this API when adding influencer to campaign
        // only use when adding influencer to group
        if (this.influencerGroup.influencer_group_id) {
            this.fetchListInfluencerBelongedToGroup(this.influencerGroup.influencer_group_id);
        }
        if (this.alreadySelectedInfluencers) {
            (_a = this.selectedInfluencers).push.apply(_a, this.alreadySelectedInfluencers);
        }
        if (this.pendingAddInfluencerToGroup) {
            this.reviewerList = this.pendingAddInfluencerToGroup.reviewList;
            this.needToReview = this.pendingAddInfluencerToGroup.addForReview;
        }
        var _a;
    };
    AddInfluencerGroupComponent.prototype.ngAfterViewInit = function () {
        if (this.pendingAddInfluencerToGroup && this.addInfluencerForReview) {
            this.addInfluencerForReview.needToReview = this.pendingAddInfluencerToGroup.addForReview;
            this.addInfluencerForReview.selectedReviewers = this.pendingAddInfluencerToGroup.reviewList ? this.pendingAddInfluencerToGroup.reviewList : [];
        }
    };
    AddInfluencerGroupComponent.prototype.fetchListInfluencerBelongedToGroup = function (influencerGroupId) {
        var _this = this;
        this.groupService.getListInfluencerBelongToGroup(influencerGroupId).subscribe(function (res) {
            if (res) {
                _this.listInfluencerBelongToCurrentGroup = res.data;
            }
        });
    };
    AddInfluencerGroupComponent.prototype.validateSelectedInfluencer = function (influencer) {
        var isSelected = this.selectedInfluencers.findIndex(function (item) { return item.influencerId === influencer.influencerId; }) >= 0;
        // if influencer already selected, show a warning message
        if (isSelected) {
            this.errorMessage = this.translate.instant('group_details.warning_message_influencer_already_selected');
            this.modalService.open(this.warningInfluencerAlreadyExistOtherGroup, undefined, true);
            return false;
        }
        return true;
    };
    AddInfluencerGroupComponent.prototype.processAddingInfluencerToGroup = function (influencer, influencerGroup) {
        var _this = this;
        // For campaign, adding the influencer immediately
        if (!influencerGroup || !influencerGroup.influencer_group_id) {
            this.showAddedInfluencerToUI(influencer);
            return;
        }
        this.groupService.getListInfluencerBelongToGroup(influencerGroup.influencer_group_id).subscribe(function (res) {
            if (res) {
                _this.listInfluencerBelongToCurrentGroup = res.data;
                var alreadyAddedToCurrentGroup = _this.listInfluencerBelongToCurrentGroup.findIndex(function (item) {
                    return item.influencer_id === influencer.influencerId && item.influencer_group_id === influencerGroup.influencer_group_id;
                }) >= 0;
                // if influencer already added, show a warning message
                if (alreadyAddedToCurrentGroup) {
                    _this.errorMessage = _this.translate.instant('group_details.warning_message_influencer_already_exist', {
                        groupName: influencerGroup.influencer_group_name
                    });
                    _this.modalService.open(_this.warningInfluencerAlreadyExistOtherGroup, undefined, true);
                    return false;
                }
                else {
                    _this.showAddedInfluencerToUI(influencer);
                }
            }
        });
    };
    AddInfluencerGroupComponent.prototype.showAddedInfluencerToUI = function (influencer) {
        var unkownInfluencer = this.selectedInfluencers.find(function (inf) { return inf.id <= 0 && influencer.channels.filter(function (channel) { return channel.handle === inf.influencerName; }).length > 0; });
        // auto pre-fill unknown influencer by selected influencer if they have the same handle
        if (unkownInfluencer) {
            unkownInfluencer.state = InfluencerSuggestionState.SINGLE_SUGGESTION;
            unkownInfluencer.channels = influencer.channels;
            unkownInfluencer.country = influencer.country;
            unkownInfluencer.countryCode = influencer.country ? influencer.country.code : '';
            unkownInfluencer.id = influencer.id;
            unkownInfluencer.influencerId = influencer.id;
        }
        else {
            // push influencer as the new selection
            influencer.state = InfluencerSuggestionState.SINGLE_SUGGESTION;
            this.selectedInfluencers.push(influencer);
        }
    };
    AddInfluencerGroupComponent.prototype.selectInfluencerSuggestion = function (influencer) {
        var isValidInfluencer = this.validateSelectedInfluencer(influencer);
        if (isValidInfluencer) {
            this.processAddingInfluencerToGroup(influencer, this.influencerGroup);
        }
    };
    AddInfluencerGroupComponent.prototype.removeInfluencer = function (influencerId, influencerName) {
        var deleteIndex;
        if (influencerId > 0) {
            deleteIndex = this.selectedInfluencers.findIndex(function (influencer) { return influencer.influencerId === influencerId; });
        }
        else {
            deleteIndex = this.selectedInfluencers.findIndex(function (influencer) { return influencer.influencerName === influencerName; });
        }
        if (deleteIndex >= 0) {
            this.selectedInfluencers.splice(deleteIndex, 1);
        }
    };
    AddInfluencerGroupComponent.prototype.onEnterInfluencer = function (e) {
        var unknowInfluencer = new InfluencerSuggestion();
        unknowInfluencer.id = 0;
        unknowInfluencer.influencerName = e.handle;
        if (e.isLoading) {
            unknowInfluencer.state = InfluencerSuggestionState.PROCESSING;
        }
        else {
            this.updateStateInfluencer(unknowInfluencer, e.suggestionList);
        }
        this.selectedInfluencers.push(unknowInfluencer);
    };
    AddInfluencerGroupComponent.prototype.afterSearchingInfluencer = function (e) {
        var _this = this;
        var processingInfluencers = this.selectedInfluencers.filter(function (inf) { return inf.state === InfluencerSuggestionState.PROCESSING && inf.id === 0; });
        processingInfluencers.forEach(function (pi) {
            if (e.hasError) {
                pi.state = InfluencerSuggestionState.ERROR;
            }
            else {
                _this.updateStateInfluencer(pi, e.suggestionList);
            }
        });
    };
    /**
     * calculate the influencer suggestion status base on it's handle and search result
     * @param {InfluencerSuggestion} processingInfluencer
     * @param {InfluencerSuggestion[]} results
     */
    AddInfluencerGroupComponent.prototype.updateStateInfluencer = function (processingInfluencer, results) {
        if (!results) {
            processingInfluencer.state = InfluencerSuggestionState.NOT_FOUND;
            return;
        }
        var matchedByHandle = results.filter(function (inf) { return inf.channels.filter(function (channel) { return channel.handle === processingInfluencer.influencerName; }).length > 0; });
        if (matchedByHandle.length === 1) {
            processingInfluencer.state = InfluencerSuggestionState.SINGLE_SUGGESTION;
            processingInfluencer.channels = matchedByHandle[0].channels;
            processingInfluencer.country = matchedByHandle[0].country;
            processingInfluencer.countryCode = matchedByHandle[0].country ? matchedByHandle[0].country.code : '';
            processingInfluencer.id = matchedByHandle[0].id;
        }
        else if (matchedByHandle.length > 1) {
            processingInfluencer.state = InfluencerSuggestionState.MULTIPLE_SUGGESTIONS;
        }
        else if (matchedByHandle.length === 0) {
            processingInfluencer.state = InfluencerSuggestionState.NOT_FOUND;
        }
    };
    AddInfluencerGroupComponent.prototype.hasPlatform = function (platformId, influencer) {
        if (!influencer.channels) {
            return false;
        }
        return influencer.channels.findIndex(function (channel) { return channel.platform.id === platformId; }) >= 0;
    };
    AddInfluencerGroupComponent.prototype.addInfluencerToGroup = function () {
        var addInfluencerGroup = this.getAddInfluencerToGroupData();
        this.addInfluencerToGroupEvent.emit({
            addInfluencerGroup: addInfluencerGroup,
            selectedInfluencers: this.selectedInfluencers,
        });
        this.closeAddInfluencerFragment({
            resetSelectedInfluencer: false,
            isReloadInfluencerList: false
        });
    };
    AddInfluencerGroupComponent.prototype.getAddInfluencerToGroupData = function () {
        var influencerIdList = this.selectedInfluencers.map(function (influencer) { return influencer.influencerId; });
        var addInfluencerGroup = {
            influencer_group_id: this.influencerGroup.influencer_group_id,
            description: '',
            influencerGroupName: this.influencerGroup.influencer_group_name,
            influencerList: influencerIdList.filter(function (id) { return id > 0; }),
            reviewList: this.reviewerList,
            addForReview: this.needToReview
        };
        return addInfluencerGroup;
    };
    AddInfluencerGroupComponent.prototype.closeAddInfluencerFragment = function (e) {
        this.closeFragmentEvent.emit(e);
        this.closeConfirmationPopup();
    };
    AddInfluencerGroupComponent.prototype.closeWithoutSaving = function (evt) {
        this.closeAddInfluencerFragment({
            resetSelectedInfluencer: true,
            isReloadInfluencerList: evt && evt.bulkUploadInfluencers ? true : false,
            isTemporaryHidden: evt && evt.isTemporaryHidden,
            bulkUploadInfluencers: evt ? evt.bulkUploadInfluencers : null,
            influencerGroupId: this.influencerGroup.influencer_group_id
        });
    };
    AddInfluencerGroupComponent.prototype.isUnknownInfluencer = function (influencer) {
        return influencer.id <= 0;
    };
    AddInfluencerGroupComponent.prototype.getCountryCode = function (influencer) {
        if (influencer && influencer.country && influencer.country.code) {
            return influencer.country.code.toLowerCase();
        }
        return influencer && influencer.countryCode ? influencer.countryCode.toLowerCase() : '';
    };
    AddInfluencerGroupComponent.prototype.getChannels = function (influencer) {
        var channelName = influencer && influencer.channels && influencer.channels.length > 0 ? influencer.channels[0].handle : influencer.influencerName;
        if (!channelName) {
            return '';
        }
        return channelName.indexOf('@') >= 0 ? channelName : "@" + channelName;
    };
    AddInfluencerGroupComponent.prototype.addNewInfluencer = function (evt) {
        this.addNewInfluencerManuallyEvent.emit({
            handle: evt.handle,
            processingIndex: evt.index,
            influencerSuggestion: evt.influencer,
            selectedInfluencers: this.selectedInfluencers,
            pendingAddInfluencerToGroup: this.getAddInfluencerToGroupData()
        });
    };
    AddInfluencerGroupComponent.prototype.selectAndAddNewInfluencer = function (evt) {
        // select new influencer by handle
        this.onEnterInfluencer({
            handle: evt.handle,
            suggestionList: []
        });
        var selectedInfluencer = this.selectedInfluencers.find(function (infl) { return infl.influencerName === evt.handle; });
        evt.influencer = selectedInfluencer;
        // add new influencer
        this.addNewInfluencer(evt);
    };
    AddInfluencerGroupComponent.prototype.validateInfluencerListBeforeAddToGroup = function () {
        var incompletedInfluencers = this.selectedInfluencers.filter(function (infl) { return infl.state === InfluencerSuggestionState.NOT_FOUND; });
        if (incompletedInfluencers.length > 0) {
            this.modalService.openInCenter(this.warningForAddingNewInfluencer);
        }
        else {
            this.addInfluencerToGroup();
        }
    };
    AddInfluencerGroupComponent.prototype.retryWhenErrorOccurred = function (evt) {
        var _this = this;
        // if an error occurred when loading influencer suggestion. Try to reload again
        if (this.autoSuggestionInfluencer.hasErrorWhenSearching) {
            this.autoSuggestionInfluencer.openSuggestionDropdown(evt.influencer.influencerName, false);
        }
        else if (this.influencerService.invalidNewInfluencer) {
            // when error occurred when call API to add new influencer. Try to add it again
            var newInfluencer = this.influencerService.invalidNewInfluencer.newInfluencer;
            var influencerChannels_1 = this.influencerService.invalidNewInfluencer.influencerChannels;
            var processingInfluencer_1 = this.selectedInfluencers[evt.index];
            processingInfluencer_1.state = InfluencerSuggestionState.PROCESSING;
            this.influencerService.addNewInfluencer(newInfluencer, influencerChannels_1, function (influencer) {
                _this.influencerService.clearInvalidInfluencerData();
                if (processingInfluencer_1) {
                    processingInfluencer_1.id = influencer.id;
                    processingInfluencer_1.influencerId = influencer.id;
                    processingInfluencer_1.channels = influencerChannels_1.map(function (c) { return ({
                        platform_id: c.platform_id,
                        handle: c.handle
                    }); });
                    processingInfluencer_1.influencerName = influencer.domain;
                    processingInfluencer_1.countryCode = influencer.country.code;
                    processingInfluencer_1.state = InfluencerSuggestionState.SINGLE_SUGGESTION;
                }
            }, function () {
                processingInfluencer_1.state = InfluencerSuggestionState.ERROR;
            });
        }
    };
    AddInfluencerGroupComponent.prototype.openMultipleHandleSelection = function (evt) {
        this.autoSuggestionInfluencer.openSuggestionDropdown(evt);
    };
    Object.defineProperty(AddInfluencerGroupComponent.prototype, "canProceedNewInfluencer", {
        get: function () {
            return this.selectedInfluencers.filter(function (inf) {
                return inf.state === InfluencerSuggestionState.PROCESSING || inf.state === InfluencerSuggestionState.ERROR;
            }).length === 0;
        },
        enumerable: true,
        configurable: true
    });
    AddInfluencerGroupComponent.prototype.closeConfirmationPopup = function () {
        this.modalService.close();
    };
    AddInfluencerGroupComponent.prototype.openConfirmationBeforeExisting = function () {
        if (this.selectedInfluencers.length > 0) {
            this.modalService.openInCenter(this.confirmationBeforeCloseAddInfluencer);
        }
        else {
            this.closeAddInfluencerFragment({
                resetSelectedInfluencer: true,
                isReloadInfluencerList: false
            });
        }
    };
    AddInfluencerGroupComponent.prototype.onChangeSelectedReviewers = function (evt) {
        this.reviewerList = evt.selectedReviewers;
        this.needToReview = evt.addForReview;
        if (evt.needToSendMPEvent) {
            this.sendMPEventWhenChangingReviewer();
        }
    };
    AddInfluencerGroupComponent.prototype.sendMPEventWhenChangingReviewer = function () {
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, {
            id: this.influencerGroup.influencer_group_id,
            name: this.influencerGroup.influencer_group_name,
            type: TargetType.REQUEST_REVIEW
        }, {
            action: UserActionType.TOGGLE,
            source: ActionSource.ACTION_VIEW
        });
    };
    Object.defineProperty(AddInfluencerGroupComponent.prototype, "hasSelectedInfluencers", {
        get: function () {
            return this.selectedInfluencers.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    return AddInfluencerGroupComponent;
}());
export { AddInfluencerGroupComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/add-influencer-group/add-influencer-group.component.ts.pre-build-optimizer.js